import { useDemand } from "lib/authorization/use-demand"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { openProjectSchedule } from "../utilities/project-navigation"
import { ScheduleListRow } from "./schedule-list-row"
import { AUTHORING_REVIEW_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function SendToLegacyBlockingScheduleRow({ schedule }) {
    const { target: project } = useBoundContext()
    const canAccessReview = useDemand(AUTHORING_REVIEW_SCHEDULES_DEMAND)
    const { cancel } = useOkCancelContext()
    const { status, id } = schedule

    return <ScheduleListRow schedule={schedule} onClick={handleOpenSchedule} data-cy="blocking-schedule-row" />

    function handleOpenSchedule() {
        cancel()
        openProjectSchedule({ projectId: project?.id, scheduleId: id, status, canAccessReview })
    }
}
